import { forefootPostingLabSpecifiedValue, forefootPostMap, heelLiftMap, postingTypeMultiplierMap, prescriptionSides, rearfootPostUndercutMap, skiveMap, } from "./values.js";
import { EnsureNumberOrNullish } from "../../util.js";
export function UpdatePosting(leftParams, rightParams, postingOptions) {
    UpdateHeelSkive(leftParams, rightParams, postingOptions);
    UpdateRearfootAndForefootPost(leftParams, rightParams, postingOptions);
}
const skiveTypes = ["medialHeelSkive", "lateralHeelSkive"];
function UpdateHeelSkive(leftParams, rightParams, postingOptions) {
    // Validate
    const hasSkive = (value) => value !== "0mm";
    const skiveCounts = { left: 0, right: 0 };
    for (const side of prescriptionSides) {
        for (const skive of skiveTypes) {
            const skiveOptions = postingOptions[skive];
            skiveCounts[side] += Number(hasSkive(skiveOptions[side]));
        }
    }
    for (const side of prescriptionSides) {
        if (skiveCounts[side] > 1) {
            throw new Error(`Cannot have both medial and lateral heel skive on ${side} foot`);
        }
    }
    leftParams.heelSkiveEnabled = false;
    rightParams.heelSkiveEnabled = false;
    for (const side of prescriptionSides) {
        for (const skive of skiveTypes) {
            const skiveOptions = postingOptions[skive];
            const skiveValue = skiveOptions[side];
            if (hasSkive(skiveValue)) {
                const params = side === "left" ? leftParams : rightParams;
                params.heelSkiveEnabled = true;
                params.heelSkiveDepth = skiveMap[skiveValue];
                params.heelSkiveIsMedial = skive === "medialHeelSkive";
            }
        }
    }
}
function GetPostingValue(value, type) {
    return forefootPostMap[value] * postingTypeMultiplierMap[type];
}
function UpdateRearfootAndForefootPost(leftParams, rightParams, postingOptions) {
    var _a;
    const params = { left: leftParams, right: rightParams };
    // If Rearfoot Post = NA and Heel Lift = 0, do not turn on rearfoot post.
    // If Heel Lift != 0, turn on rearfoot post. (including if Rearfoot Post = NA)
    // If Rearfoot Post != NA, turn on rearfoot. (including if Heel Lift = 0)
    // Rearfoot post
    const rearfootPost = postingOptions.rearfootPost;
    const rearfootOverride = rearfootPost.override;
    for (const side of prescriptionSides) {
        const param = params[side];
        param.heelPostingEnabled = false;
        param.heelPostingAlpha = forefootPostMap["0deg"];
        param.heelPostingWidth = heelLiftMap["0mm"];
        param.heelPostingGamma = rearfootPostUndercutMap["standard"];
        param.heelPostingDelta = 0;
        switch (rearfootOverride) {
            case "none":
                break;
            case "lab-specifies":
                param.heelPostingEnabled = true;
                param.heelPostingAlpha = forefootPostMap[forefootPostingLabSpecifiedValue];
                break;
            case "specify":
                const postValue = rearfootPost[side];
                if (postValue !== undefined) {
                    param.heelPostingEnabled = true;
                    param.heelPostingAlpha = GetPostingValue(postValue.value, postValue.type);
                }
                break;
            default:
                unreachable(rearfootOverride);
        }
    }
    // Heel lift
    const hasHeelLift = (value) => value !== "0mm";
    for (const side of prescriptionSides) {
        const param = params[side];
        const heelLiftValue = postingOptions.heelLift[side];
        param.heelPostingWidth = heelLiftMap[heelLiftValue];
        param.heelPostingEnabled || (param.heelPostingEnabled = hasHeelLift(heelLiftValue));
    }
    // Rearfoot post undercut
    if (postingOptions.rearfootPostUndercut !== undefined) {
        for (const side of prescriptionSides) {
            if (params[side].heelPostingEnabled) {
                params[side].heelPostingGamma = rearfootPostUndercutMap[postingOptions.rearfootPostUndercut];
            }
        }
    }
    // Forefoot post, must be after rearfoot post
    const forefootPost = postingOptions.forefootPost;
    const forefootOverride = forefootPost.override;
    for (const side of prescriptionSides) {
        const param = params[side];
        const postValue = forefootPost[side];
        param.forefootPostingBalanceToRearfoot = false;
        param.forefootPostingAngle = 0;
        param.forefootPostingMeshEnabled = false;
        switch (forefootOverride) {
            case "none":
                break;
            case "extrinsic":
                param.forefootPostingExtrinsic = true;
                param.forefootPostingMeshEnabled = true;
                if (postValue !== undefined) {
                    param.forefootPostingAngle = GetPostingValue(postValue.value, postValue.type);
                    switch (postValue.pattern) {
                        case "honeycomb":
                            param.forefootPostingMeshType = "solid";
                            param.forefootPostingHexagonPatternEnabled = true;
                            break;
                        case "filled":
                            param.forefootPostingMeshType = "solid";
                            param.forefootPostingHexagonPatternEnabled = false;
                            break;
                        case "hollow":
                            param.forefootPostingMeshType = "hollow";
                            param.forefootPostingHexagonPatternEnabled = false;
                            break;
                        default:
                            unreachable(postValue.pattern);
                    }
                }
                else {
                    // Set defaults
                    param.forefootPostingMeshType = "hollow";
                    param.forefootPostingHexagonPatternEnabled = false;
                }
                break;
            case "balance":
                param.forefootPostingBalanceToRearfoot = true;
                param.forefootPostingAngle = -((_a = EnsureNumberOrNullish(param.heelPostingAlpha)) !== null && _a !== void 0 ? _a : 0);
                break;
            case "intrinsic":
                if (postValue !== undefined) {
                    param.forefootPostingAngle = GetPostingValue(postValue.value, postValue.type);
                }
                break;
            default:
                unreachable(forefootOverride);
        }
    }
}
//# sourceMappingURL=posting.js.map